import { CpfValidationError } from '../models/validation-errors.model';

/**
 * Validates a Brazilian CPF number with reason-specific error codes.
 * @param value - CPF string (with or without formatting)
 * @returns ValidationErrors with reason code or null if valid
 */
export function validateCpf(value: string): CpfValidationError | null {
  if (!value) return null;

  // Remove formatting (dots and dashes)
  const cpf = value.replace(/\D/g, '');

  // Check length
  if (cpf.length !== 11) {
    return { cpf: { reason: 'length', expected: 11, actual: cpf.length } };
  }

  // Check for all same digits (e.g., 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cpf)) {
    return { cpf: { reason: 'allSameDigits' } };
  }

  // Validate first check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf[i], 10) * (10 - i);
  }
  let checkDigit = 11 - (sum % 11);
  if (checkDigit >= 10) checkDigit = 0;

  if (checkDigit !== parseInt(cpf[9], 10)) {
    return { cpf: { reason: 'checksumFirstDigit' } };
  }

  // Validate second check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf[i], 10) * (11 - i);
  }
  checkDigit = 11 - (sum % 11);
  if (checkDigit >= 10) checkDigit = 0;

  if (checkDigit !== parseInt(cpf[10], 10)) {
    return { cpf: { reason: 'checksumSecondDigit' } };
  }

  return null;
}
